<form [formGroup]="identityForm" (ngSubmit)="submitForm()" class="flex justify-center">
  <mat-card>
    <section class="flex gap-5">
      <mat-form-field>
        <mat-label>Nom</mat-label>
        <input type="text" matInput placeholder="Saisir le nom" formControlName="lastname" ng-pattern="/^[a-zA-Z0-9]*$/" />
        <mat-error *ngIf="lastname.hasError('required')">Vous devez saisir un nom</mat-error>
        <mat-error *ngIf="lastname.hasError('pattern')">Aucun caractère spécial ne doit être présent
          (#,&,$...)</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Prénom</mat-label>
        <input matInput placeholder="Saisir le prénom" formControlName="firstname" ng-pattern="/^[a-zA-Z0-9]*$/" />
        <mat-error *ngIf="firstname.hasError('required')">Vous devez saisir un prénom</mat-error>
        <mat-error *ngIf="firstname.hasError('pattern')">Aucun caractère spécial ne doit être présent
          (#,&,$...)</mat-error>
      </mat-form-field>
    </section>
    <mat-card-actions class="center-actions">
      <button mat-raised-button type="submit">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>